import { render, staticRenderFns } from "./GeneralList.vue?vue&type=template&id=2c2cdfe9"
import script from "./GeneralList.vue?vue&type=script&lang=js"
export * from "./GeneralList.vue?vue&type=script&lang=js"
import style0 from "./GeneralList.vue?vue&type=style&index=0&id=2c2cdfe9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports